export const updateStateList = (stateList, nodeToUpdate) => {
  const index = stateList.findIndex(o => o.node.id === nodeToUpdate.id);

  // Item is not in the list: there is nothing to update, and we must NOT insert
  // it. A single-item detail view (e.g. opening a news article from an email
  // link) must not inject its item into an otherwise-unloaded overview list,
  // otherwise the overview ends up showing only that one item (ART-19122).
  if (index === -1) {
    return stateList;
  }

  const updatedList = [...stateList];
  updatedList[index] = {
    ...stateList[index],
    node: { ...stateList[index].node, ...nodeToUpdate },
  };

  return updatedList;
};
